const page_loader = function() {
    alert("page loader ready");
};

export {page_loader};
